import React, { Fragment } from 'react'
import { Input, Button } from '@drifthq/tide-core'
import { isURL } from 'validator'

const ProfileDetailsStep = ({
  companyName,
  companyUrl,
  onCompanyNameChange,
  onCompanyUrlChange,
  onContinueClick,
}) => (
  <Fragment>
    <h1>Personalize your Conversational Sales Profile</h1>
    <p>Your Drift Profile is your digital business card where people can book meetings and chat in real time with you.</p>
    <Input
      label="What's your company name?"
      placeholder="Dunder Mifflin"
      value={companyName}
      onChange={onCompanyNameChange}
    />
    <Input
      label="What's your company URL?"
      placeholder="www.dundermifflin.com"
      value={companyUrl}
      onChange={onCompanyUrlChange}
    />
    <Button
      onClick={onContinueClick}
      disabled={!companyName || !isURL(companyUrl)}
    >
      Continue to your Password
    </Button>
  </Fragment>
)

export default ProfileDetailsStep



// WEBPACK FOOTER //
// ./src/layouts/ProfileDetailsStep/component.js